module.exports = __webpack_public_path__ + "img/svg/gcoin.b3028bcbd7091847a77b625625b898d8.svg";